// src/components/UI/components/DropdownMenu/DropdownMenuRadioGroup.tsx

import { RadioGroup } from '@radix-ui/react-dropdown-menu';

export const DropdownMenuRadioGroup = RadioGroup;
DropdownMenuRadioGroup.displayName = 'DropdownMenuRadioGroup';
